<mat-card class="decoration-card">
    <mat-card-content>
        <mat-toolbar *ngIf="!isReadonly">
            <button mat-icon-button matTooltip="update" (click)="updateTest()" [disabled]="!isContentChanged" *ngIf="!isReadonly">
                <mat-icon>save</mat-icon>
            </button>

            <span class="example-spacer"></span>

            <button mat-icon-button matTooltip="add a test" (click)="createTest()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>

            <button mat-icon-button matTooltip="delete" (click)="btnDeleteClicked()" *ngIf="!isReadonly">
                <mat-icon>delete_outline</mat-icon>
            </button>
        </mat-toolbar>

        <form class="example-form" (change)="onContentChange()">
            <table class="example-full-width" cellspacing="0">
                <tr>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                        <mat-label>SN</mat-label>
                        <input matInput type="text" name="SN" [(ngModel)]="test.sn" [readonly]="isReadonly">
                    </mat-form-field></td>

                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                        <mat-label>Name</mat-label>
                        <input matInput type="text" name="Name" [(ngModel)]="test.name" [readonly]="isReadonly">
                    </mat-form-field></td>
                </tr>

                <tr>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                        <mat-label>System</mat-label>
                        <input matInput type="text" name="system" [(ngModel)]="test.system" [readonly]="isReadonly">
                    </mat-form-field></td>

                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                        <mat-label>Subsystem</mat-label>
                        <input matInput type="text" name="subsystem" [(ngModel)]="test.subsystem" [readonly]="isReadonly">
                    </mat-form-field></td>
                </tr>
            </table>

            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>FMEA reference</mat-label>
                <textarea matInput type="text" name="FMEA" [(ngModel)]="test.fmea_reference" [readonly]="isReadonly"></textarea>
            </mat-form-field>

            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Test objective</mat-label>
                <textarea matInput type="text" name="test_objective" [(ngModel)]="test.test_objective" [readonly]="isReadonly"></textarea>
            </mat-form-field>

            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Rolling programm</mat-label>
                <input matInput type="text" name="rolling_programm" [(ngModel)]="test.rolling_programm" [readonly]="isReadonly">
            </mat-form-field>

            <table class="example-full-width" cellspacing="0">
                <tr>
                    <td><mat-form-field class="example-full-width" [class.isReadonly]="isReadonly" [appearance]="fieldAppearance">
                        <mat-label>Images required</mat-label>
                        <mat-select name="images_required" [(ngModel)]="image_required" (ngModelChange)="imageRequiredOptionChanged()">
                            @for (item of image_required_options; track item) {
                            <mat-option [value]="item">{{item.expression}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field></td>

                    <td><mat-form-field class="example-full-width" [class.isReadonly]="isReadonly" [appearance]="fieldAppearance">
                        <mat-label>Can be performed by crew</mat-label>
                        <mat-select name="crew_perform" [(ngModel)]="crew_perform" (ngModelChange)="crewPerformOptionChanged()">
                            @for (item of crew_perform_options; track item) {
                            <mat-option [value]="item">{{item.expression}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field></td>

                </tr>
            </table>

            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Test procedure setup</mat-label>
                <textarea matInput type="text" name="procedure" [(ngModel)]="test.test_procedure_setup" [readonly]="isReadonly"></textarea>
            </mat-form-field>

            <table class="example-full-width" cellspacing="0">
                <tr>
                    <td><mat-form-field class="example-full-width" [class.isReadonly]="isReadonly" [appearance]="fieldAppearance">
                        <mat-label>Test completed</mat-label>
                        <mat-select name="test_completed" [(ngModel)]="test_completed" (ngModelChange)="testCompletedOptionChanged()">
                            @for (item of test_completed_options; track item) {
                            <mat-option [value]="item">{{item.expression}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field></td>
                </tr>
                <tr>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>Complete date</mat-label>
                            <input matInput type="date" name="complete_date" [(ngModel)]="test.complete_date" [readonly]="isReadonly">
                            <mat-hint>DD/MM/YYYY</mat-hint>
                        </mat-form-field></td>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>Witnessed by</mat-label>
                            <input matInput type="text" name="witnessed_by" [(ngModel)]="test.witnessed_by" [readonly]="isReadonly">
                        </mat-form-field></td>
                </tr>
            </table>

            <mat-form-field class="example-full-width remark" [appearance]="fieldAppearance">
                <mat-label>Remark</mat-label>
                <textarea matInput type="text" name="remark" [(ngModel)]="test.remark" [readonly]="isReadonly"></textarea>
            </mat-form-field>

        </form>

    </mat-card-content>
</mat-card>